import { DeepstreamClient } from '@deepstream/client';
import { useState, useEffect } from 'react';
import config from './config';

let client = null;
let currentLoginData = null;
let authToken = null;

export const getClient = () => {
  if (!client || ['CLOSED', 'ERROR'].includes(client.getConnectionState())) {
    client = new DeepstreamClient(config.deepstreamServerUrl);
    client.on('error', (error, event, topic) => {
      console.error('error', error, event, topic);
    });
  }

  return client;
};

export const closeClient = () =>
  new Promise(resolve => {
    if (!client || client.getConnectionState() === 'CLOSED') {
      resolve();
      return;
    }

    client.on('connectionStateChanged', connectionState => {
      if (connectionState === 'CLOSED') resolve();
    });

    client.close();
  });

export const setAuthToken = token => (authToken = token);

export const login = ({ userId, boardId }) =>
  new Promise((resolve, reject) => {
    const loginData = `${userId}_${boardId}`;
    if (currentLoginData !== loginData) {
      if (client) client.close();
      client = new DeepstreamClient(config.deepstreamServerUrl);
    }

    getClient().login(
      { authToken, projectId: boardId, connectionType: 'client' },
      (success, data) => {
        if (success) resolve(data);
        else reject(data);
      }
    );
  });

export const getRecord = recordId => getClient().record.getRecord(recordId);
export const getList = listId => getClient().record.getList(listId);
export const makeRpc = (name, data) =>
  new Promise((resolve, reject) => {
    getClient().rpc.make(name, data, (error, result) => {
      if (error) {
        reject(error);
        return;
      }
      resolve(result);
    });
  });

export const emitEvent = (name, data) => getClient().event.emit(name, data);
export const subscribeToEvent = (name, callback) => getClient().event.subscribe(name, callback);
export const unsubscribeFromEvent = (name, callback) =>
  getClient().event.unsubscribe(name, callback);

export const useList = listId => {
  const [listItems, setListItems] = useState([]);

  useEffect(() => {
    const listRecord = getList(listId);
    listRecord.subscribe(setListItems, true);

    return () => {
      listRecord.unsubscribe(setListItems);
    };
  }, [listId]);

  return listItems;
};

export const useRecord = recordId => {
  const initiallyAvailableData = getRecord(recordId).get();
  const [recordData, setRecordData] = useState(initiallyAvailableData);

  useEffect(() => {
    const record = getRecord(recordId);
    record.subscribe(setRecordData, true);

    return () => {
      record.unsubscribe(setRecordData);
    };
  }, [recordId]);

  return recordData;
};
